/** Compose display name from Name / Father-Husband / Surname parts. */
export function composeFullName(name, fatherHusbandName, surname) {
  return [name, fatherHusbandName, surname]
    .map((p) => String(p || '').trim())
    .filter(Boolean)
    .join(' ');
}

/**
 * Age in whole years from DOB string (YYYY-MM-DD from <input type="date">).
 * Returns null if invalid / empty.
 */
export function ageFromDob(dob) {
  if (!dob) return null;
  const d = new Date(dob);
  if (Number.isNaN(d.getTime())) return null;
  const today = new Date();
  let age = today.getFullYear() - d.getFullYear();
  const m = today.getMonth() - d.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < d.getDate())) age -= 1;
  return age >= 0 ? age : null;
}

/** Format ISO date (YYYY-MM-DD or full ISO datetime) as DD/MM/YYYY for display. */
export function formatDobDisplay(dob) {
  if (!dob) return '—';
  const match = String(dob).trim().match(/^(\d{4}-\d{2}-\d{2})/);
  if (!match) return String(dob);
  const [y, m, d] = match[1].split('-');
  return `${d}/${m}/${y}`;
}
